"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGmailOAuthReturn = exports.getConstantContactOAuthRedirectUri = exports.getMailchimpOAuthReturn = exports.getReviewOAuthStatePrefix = exports.getReviewAppTag = exports.GMAIL_REVIEW_OAUTH_RETURN_URL = exports.QUICKBOOKS_REVIEW_OAUTH_RETURN_URL = exports.CONSTANT_CONTACT_OAUTH_RETURN_PATH = exports.CONSTANT_CONTACT_REVIEW_OAUTH_RETURN_URL = exports.MAILCHIMP_REVIEW_OAUTH_RETURN_URL = void 0;
const routes_1 = require("../routes");
const REVIEW_OAUTH_FORWARDER_URL = "https://oauth.review.zeffy.com";
exports.MAILCHIMP_REVIEW_OAUTH_RETURN_URL = `${REVIEW_OAUTH_FORWARDER_URL}/mailchimp`;
exports.CONSTANT_CONTACT_REVIEW_OAUTH_RETURN_URL = `${REVIEW_OAUTH_FORWARDER_URL}/constantcontact`;
exports.CONSTANT_CONTACT_OAUTH_RETURN_PATH = "/o/sso/connect-constant-contact";
exports.QUICKBOOKS_REVIEW_OAUTH_RETURN_URL = `${REVIEW_OAUTH_FORWARDER_URL}/quickbooks`;
exports.GMAIL_REVIEW_OAUTH_RETURN_URL = `${REVIEW_OAUTH_FORWARDER_URL}/google`;
const REVIEW_APP_FRONTEND_URL = /^https:\/\/pr-(\d+)\.review\.zeffy\.com\/?$/;
const getReviewAppTag = (frontendUrl) => {
    const pullRequestNumber = frontendUrl ? REVIEW_APP_FRONTEND_URL.exec(frontendUrl)?.[1] : undefined;
    return pullRequestNumber ? `pr${pullRequestNumber}` : null;
};
exports.getReviewAppTag = getReviewAppTag;
const getReviewOAuthStatePrefix = (frontendUrl) => {
    const reviewAppTag = (0, exports.getReviewAppTag)(frontendUrl);
    return reviewAppTag ? `${reviewAppTag}-` : "";
};
exports.getReviewOAuthStatePrefix = getReviewOAuthStatePrefix;
const getMailchimpOAuthReturn = (frontendUrl) => {
    const statePrefix = (0, exports.getReviewOAuthStatePrefix)(frontendUrl);
    return statePrefix
        ? { redirectUri: exports.MAILCHIMP_REVIEW_OAUTH_RETURN_URL, statePrefix }
        : { redirectUri: `${frontendUrl}${routes_1.OrganizationRoutes.ImportMailChimpContacts}`, statePrefix: "" };
};
exports.getMailchimpOAuthReturn = getMailchimpOAuthReturn;
const getConstantContactOAuthRedirectUri = (frontendUrl) => (0, exports.getReviewOAuthStatePrefix)(frontendUrl)
    ? exports.CONSTANT_CONTACT_REVIEW_OAUTH_RETURN_URL
    : `${frontendUrl}${exports.CONSTANT_CONTACT_OAUTH_RETURN_PATH}`;
exports.getConstantContactOAuthRedirectUri = getConstantContactOAuthRedirectUri;
const getGmailOAuthReturn = (frontendUrl) => {
    const statePrefix = (0, exports.getReviewOAuthStatePrefix)(frontendUrl);
    return statePrefix
        ? { redirectUri: exports.GMAIL_REVIEW_OAUTH_RETURN_URL, statePrefix }
        : { redirectUri: `${frontendUrl}${routes_1.OrganizationRoutes.ImportGMailContacts}`, statePrefix: "" };
};
exports.getGmailOAuthReturn = getGmailOAuthReturn;
